const OBJECT_TYPE_ALIASES = Object.freeze({
    mail: 'email',
});

function hasMandatoryIf(prop) {
    return typeof prop?.mandatoryIf === 'string' && prop.mandatoryIf.trim() !== '';
}

export function canonicalObjectType(rawType) {
    if (typeof rawType !== 'string') return null;
    const lower = rawType.trim().toLowerCase();
    if (!lower) return null;
    return OBJECT_TYPE_ALIASES[lower] || lower;
}

export function isAllowlistedProperty(prop) {
    if (!prop || typeof prop !== 'object') return false;
    if (prop.core === true) return true;
    if (prop.configured === true) return true;
    if (prop.mandatory === true) return true;
    if (hasMandatoryIf(prop)) return true;
    return false;
}

export function shouldKeepCustomProperty(prop) {
    if (!prop || typeof prop !== 'object') return false;
    if (prop.core === true) return false;
    return isAllowlistedProperty(prop);
}

export function filterAllowlistedProperties(properties) {
    if (!Array.isArray(properties)) return [];
    return properties.filter(isAllowlistedProperty);
}

